import React from 'react';
import { FlexibleComponents, FlexFaq } from 'day8-react/build/new-components';
import PageLayout from '../layouts/page';
import { DestinationType, WpPageType } from '../globalTypes';

const WPPageWrapper = ({ page, destinations }: { page: WpPageType, destinations: DestinationType[] | undefined }) => (
  <PageLayout page={page} signupHidden={page?.acf?.hide_footer_signup}>
    {page?.acf?.components && <FlexibleComponents components={page.acf.components} destinations={destinations} />}
    <div dangerouslySetInnerHTML={{ __html: page?.content?.rendered || '' }} />
    {page?.acf?.faq && <FlexFaq title={page.acf?.faqtitle} faq={page.acf?.faq} />}
  </PageLayout>
);

export default WPPageWrapper;
